import React, { useState } from "react";
import GridTable from "cvmgmt-cube-grid-table";
import { IconButton } from "@mui/material";
import { getEnv } from "../../Constants/env";
import JustificationDialog from "../../Components/Modals/JustificationDialog";
import { useSelector } from "react-redux";
import { useIdToken } from "../../hooks/useAuthSession";
import { MdOutlineFileDownload } from "react-icons/md";
import { axiosInstance } from "../../utils/axiosInstance";
import { triggerToast } from "../../utils/toast";
import { downloadBlobFile } from "../../utils/commonUtil";

const ArchivedRoleAssignmentRequests = () => {
  const [refreshValue] = useState<number>(0);
  const idToken = useIdToken();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [popupData, setPopupData] = useState<any>(null);
  const { env } = useSelector((state: any) => state?.createApplication);

  const handleDownloadRequests = async () => {
    try {
      const response = await axiosInstance.post(
        `/onboard/grid-export`,
        {
          serviceUrl: "/request/denied/myrequest",
          sortingFilter: {
            filter: [],
            sort: [],
            columns: [],
            page: {
              limit: 10,
              offset: 1,
            },
          },
          fileName: "archived_requests",
          sheetName: "archived_requests",
        },
        {
          responseType: "blob",
          headers: {
            Accept: "application/vnd.ms-excel",
          },
        },
      );

      const disposition = response?.headers?.["content-disposition"] || "";
      const fileNameMatch = disposition.match(
        /filename\*?=(?:UTF-8''|\")?([^\";]+)/i,
      );
      const fileName = decodeURIComponent(
        (fileNameMatch?.[1] || "archived_requests.xlsx").replace(/\"/g, ""),
      );

      downloadBlobFile(response?.data, fileName);
      triggerToast("Requests downloaded successfully", "success");
    } catch (error: any) {
      triggerToast(error?.message || "Unable to download requests", "error");
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setPopupData(null);
  };

  return (
    <>
      {idToken && (
        <GridTable
          customPayload={true}
          style={{ height: "calc(100vh - 30rem)" }}
          isCustomizeColumns={false}
          title={"Access Status"}
          actions={[
            {
              event: "save",
              component: (
                <IconButton
                  onClick={handleDownloadRequests}
                  id="ArchivedRoleAssignmentRequestsDownload"
                  title="Download"
                >
                  <MdOutlineFileDownload
                    style={{ fontSize: "20px" }}
                    id="archived-requests-icon-download"
                  />
                </IconButton>
              ),
            },
          ]}
          onRowClick={(_event: any, row: any) => {
            setDialogOpen(true);
            setPopupData(row?.original?.feature_permission_justification);
          }}
          apiConfig={{
            url: `${getEnv()?.baseURL}/request/denied/myrequest?env=${env}`,
            data: {
              sortingFilter: {
                filter: [],
                sort: [],
                page: {
                  limit: 10,
                  offset: 1,
                },
              },
            },
            headers: {
              Authorization: idToken,
              "x-api-key": "sasa",
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            documentUrl: "",
          }}
          refresh={refreshValue}
          showLoader={false}
        />
      )}
      <JustificationDialog
        isStatus
        isSubRequestId
        open={dialogOpen}
        onClose={handleDialogClose}
        row={popupData}
      />
    </>
  );
};

export default ArchivedRoleAssignmentRequests;
